(function () {
  function initMaps() {
    var containers = document.querySelectorAll('[data-origin-notes-map]');
    containers.forEach(function (container) {
      if (container.dataset.mapReady === 'true') return;
      var hasPoint = container.dataset.lat && container.dataset.lng;
      var circles = hasPoint ? [container] : container.querySelectorAll('.map-circle');
      if (!circles.length) return;

      var first = circles[0];
      var center = {
        lat: parseFloat(first.dataset.lat),
        lng: parseFloat(first.dataset.lng)
      };

      var map = new google.maps.Map(container, {
        zoom: 13,
        center: center,
        mapTypeId: 'terrain'
      });

      circles.forEach(function (circleEl) {
        var color = circleEl.dataset.color || '#000000';
        new google.maps.Circle({
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.35,
          map: map,
          center: {
            lat: parseFloat(circleEl.dataset.lat),
            lng: parseFloat(circleEl.dataset.lng)
          },
          radius: parseFloat(circleEl.dataset.radius || '2000')
        });
      });

      container.dataset.mapReady = 'true';
    });
  }

  function initMapsInView() {
    if (!(window.google && window.google.maps)) return;
    var containers = document.querySelectorAll('[data-origin-notes-map]');
    containers.forEach(function (container) {
      if (container.dataset.mapReady === 'true') return;
      var rect = container.getBoundingClientRect();
      var inView = rect.width > 0 && rect.height > 0 && rect.bottom >= 0 && rect.top <= window.innerHeight;
      if (inView) {
        initMaps();
      }
    });
  }

  function getApiKey() {
    var el = document.querySelector('[data-origin-notes-map][data-google-maps-api-key]');
    return el ? el.dataset.googleMapsApiKey : '';
  }

  function loadGoogleMaps() {
    if (window.__smOriginNotesMapScriptLoading) return;
    if (window.google && window.google.maps) {
      initMapsInView();
      return;
    }
    var apiKey = getApiKey();
    if (!apiKey) return;
    window.__smOriginNotesMapScriptLoading = true;
    window.__smOriginNotesMapInit = initMaps;
    var script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&callback=__smOriginNotesMapInit';
    document.head.appendChild(script);
  }

  function setupObserver() {
    var maps = document.querySelectorAll('[data-origin-notes-map]');
    if (!maps.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var anyVisible = entries.some(function (entry) { return entry.isIntersecting; });
        if (anyVisible) {
          loadGoogleMaps();
          observer.disconnect();
        }
      }, { rootMargin: '200px 0px' });
      maps.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      var lazyLoadHandler = function () {
        loadGoogleMaps();
        window.removeEventListener('mousemove', lazyLoadHandler);
        window.removeEventListener('mousewheel', lazyLoadHandler);
        window.removeEventListener('touchstart', lazyLoadHandler);
        window.removeEventListener('scroll', lazyLoadHandler);
      };
      window.addEventListener('mousemove', lazyLoadHandler, { once: true });
      window.addEventListener('mousewheel', lazyLoadHandler, { once: true });
      window.addEventListener('touchstart', lazyLoadHandler, { once: true });
      window.addEventListener('scroll', lazyLoadHandler, { once: true });
    }

    window.addEventListener('resize', initMapsInView);
    document.addEventListener('click', function () {
      setTimeout(initMapsInView, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();
